/**
 * @desc getCountry
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<Array<defs.tms.CountryResponseDto>>;
export function request(params: API.tms.test.getCountry.Params, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/test/getCountry`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
